import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolvePostAuthDestination } from "@/lib/route-access";
import type { RouterContext } from "@/lib/router-context";

export const Route = createFileRoute("/app/")({
  beforeLoad: async ({ context }) => {
    const ctx = context as RouterContext;
    const session = await ctx.ensureSession();
    if (!session) {
      throw redirect({
        to: "/auth",
        search: {
          redirect: "/dashboard",
        },
      });
    }

    throw redirect({
      to: resolvePostAuthDestination(session, "/dashboard"),
      replace: true,
    });
  },
});
